/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */


const controlledAccordionSectionStyle = {
  headline: {
    textAlign: "center",
    marginBottom: "3rem",
  },
};

export default controlledAccordionSectionStyle;
